var _templateObject;

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

import React, { useRef } from 'react';
import root from 'react-shadow/styled-components';
import Authentication from '../Authentication';
import { Theme } from '../Theme';
import { createGlobalStyle } from 'styled-components';
var Style = createGlobalStyle(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n    .squeak {\n        .squeak-avatar-container {\n            display: none;\n        }\n        .squeak-authentication-form-container {\n            margin-left: 0;\n        }\n    }\n"])));
export var Login = function Login(_ref) {
  var onSubmit = _ref.onSubmit,
      buttonText = _ref.buttonText;
  var containerRef = useRef();
  return /*#__PURE__*/React.createElement(root.div, {
    ref: containerRef
  }, /*#__PURE__*/React.createElement(Theme, {
    containerRef: containerRef
  }), /*#__PURE__*/React.createElement(Style, null), /*#__PURE__*/React.createElement("div", {
    className: "squeak"
  }, /*#__PURE__*/React.createElement(Authentication, {
    buttonText: buttonText,
    handleMessageSubmit: onSubmit
  })));
};